import React, {MouseEventHandler} from "react";

import "core/event/component/htmlThumbnail.less";

export const HtmlThumbnail = ({html, onClick}: {html: string, onClick: MouseEventHandler<any>}) => {

  if (!html) html = "<div>EMPTY BODY</div>";

  return (
    <div className="thumbnail-container" onClick={onClick}>
      <div className="thumbnail">
        <iframe srcDoc={html} frameBorder="0"></iframe>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/core/event/component/htmlThumbnail.tsx